import Selective from "./Selective";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import Additive from "./Additive";
import Image from "./Image";
import Category from "./Category";
import Discount from "./Discount";
import {Variant} from "./Variant";

export type OrderTypes = "table" | "takeaway" | "outside";

@usingJsonToModelConvertor
export class Product extends Model {

    @fromJsonObject({key: "id"})
    public id!: number;

    @fromJsonObject({key: "branch_id"})
    public branchId!: number;

    @fromJsonObject({key: "name"})
    public name!: string;

    @fromJsonObject({key: "variant_name"})
    public fullName!: string;

    @fromJsonObject({key: "price"})
    public price!: number;

    @fromJsonObject({key: "is_hidden", modelClass: Boolean})
    public isHidden!: boolean;

    @fromJsonObject({key: "description"})
    public description!: string;

    @fromJsonObject({key: "packing_price"})
    public packingPrice!: number;

    @fromJsonObject({key: "order_types"})
    public orderTypes!: OrderTypes[];

    @fromJsonObject({key: "preparing_time"})
    public preparingTime!: number;

    @fromJsonObject({key: "is_variant"})
    public isVariant!: boolean;

    @fromJsonObject({key: "has_variants"})
    public hasVariants!: boolean;

    @fromJsonObject({key: "is_parent_product"})
    public isParentProduct!: boolean;

    @fromJsonObject({key: "variant_of_id"})
    public parentProductId!: number;

    @fromJsonObject({key: "order_able"})
    public orderAble!: boolean;

    @fromJsonObject({key: "price_with_discount"})
    public priceWithDiscount!: number;

    @fromJsonObject({key: "has_active_discount"})
    public hasActiveDiscount!: boolean;

    @fromJsonObject({key: "logo"})
    public logo!: string;

    @fromJsonObject({key: "categories", modelClass: Category, isArray: true})
    public categories!: Category[];

    @fromJsonObject({key: "selectives", modelClass: Selective, isArray: true})
    public selectives!: Selective[];

    @fromJsonObject({key: "additives", modelClass: Additive, isArray: true})
    public additives!: Additive[];

    @fromJsonObject({key: "images", modelClass: Image, isArray: true})
    public images!: Image[];

    @fromJsonObject({key: "variants", modelClass: Variant, isArray: true})
    public variants!: Variant[];

    @fromJsonObject({key: "active_discounts", modelClass: Discount, isArray: true})
    public activeDiscounts!: Discount[];

    hasImage() {
        if (this.images != undefined)
            if (this.images.length != 0)
                return true;
        return false;
    }

    hasSelective() {
        if (this.selectives != null)
            if (this.selectives.length != 0)
                return true;
        return false;
    }

    hasAdditives() {
        if (this.additives != null)
            if (this.additives.length != 0)
                return true;
        return false;
    }

    needsProductAdderDialog() {
        if (this.hasSelective())
            return true;
        if (this.hasAdditives())
            return true;
        if (this.hasVariants)
            return true;
        return false;
    }
}
